import { dualPrice, isZeroPrice } from "@/lib/price";

// Shows a price in ISK with the approximate conversion smaller behind it —
// EUR for clients based in Europe, USD for the rest of the world.
// Unparseable prices render unchanged; a zero price renders as nothing.
export const DualPrice = ({ value, region, className = "", smallClassName = "text-neutral-500" }) => {
  if (isZeroPrice(value)) return null;
  const d = dualPrice(value, region);
  if (!d) return <span className={className}>{value}</span>;
  return (
    <span className={className}>
      {d.isk}
      <span className={`ml-2 text-[0.72em] font-normal normal-case tracking-normal ${smallClassName}`}>{d.second}</span>
    </span>
  );
};
